import { Typography, useTheme } from "@mui/material";

export const PropertySubheader = ({ value }) => {
  const theme = useTheme();

  return (
    <Typography
      component="span"
      color={`${theme.palette.primary.dark}`}
      my={4}
      textAlign="center"
      textTransform="uppercase"
      width={1}
    >
      {value}
    </Typography>
  );
};
